import { render, staticRenderFns } from "./FloatingCallWidget.vue?vue&type=template&id=2b334af7&scoped=true&"
import script from "./FloatingCallWidget.vue?vue&type=script&lang=js&"
export * from "./FloatingCallWidget.vue?vue&type=script&lang=js&"
import style0 from "./FloatingCallWidget.vue?vue&type=style&index=0&id=2b334af7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b334af7",
  null
  
)

export default component.exports